import React from "react";
import { InputStyled } from "../../styles/StyledComponents/InputStyled";
import { InputProps, TextareaProps } from "../interface";

export type IInputWrapProps = InputProps | TextareaProps;

const InputWrap: React.FC<IInputWrapProps> = (props) => {
  const { labelText, placeholder, id, name } = props;

  return (
    <InputStyled>
      {labelText && <label htmlFor={id}>{labelText}</label>}
      {"multiline" in props && props.multiline ? (
        <div className="cmn_input_Wrap">
          <textarea id={id} name={name} placeholder={placeholder} {...props} />
        </div>
      ) : (
        <div className="cmn_input_Wrap">
          <input id={id} name={name} placeholder={placeholder} {...props} />
        </div>
      )}
    </InputStyled>
  );
};

export default InputWrap;
